export default __webpack_public_path__ + "static/media/rightElement.4a4bb41d.png";